const Devices = {
  COMPUTER: 'computer',
  TABLET: 'tablet',
  SMARTPHONE: 'smartphone',
};

export default Devices;
